<template>
  
    <form role="form" @submit="onFormSubmit" name="update-role">
        <div class="form-group row">
            <label for="updateModules" class="col-lg-3 col-form-label">Modules</label>
            <div class="col-lg-9">
              <v-select id="updateModules" placeholder="Modules" multiple v-model="form.modules" :options="availableModules"></v-select>
            </div>
        </div>
        <button class="btn btn-primary ladda-button" data-style="zoom-in" type="submit">Update</button>
    </form>

</template>

<script lang="ts">
import Vue from '@fwk-node-modules/vue';
import { Component, Prop } from '@fwk-node-modules/vue-property-decorator';
import * as api from '@fwk-client/utils/api';
import * as Ladda from 'ladda';
import { messagesTypes, MessageTypes } from '@fwk-client/store/types';

@Component({
  components: { }
})
export default class Update extends Vue {

  @Prop({
    type: Object,
    required: false
  }) readonly role!: any | undefined

  availableModules:string[] = [];

  form = {
    modules : this.role.modules
  };

  laddaSubmit:Ladda.LaddaButton|null = null;

  created() {
    // We need to get the list of available modules for the current logged in user
    var options:api.ApiVueOptions =  {
      app: this
    }
    api.getAPI('/api/admin/roles/available-modules', options).then((response:any) => {
      if(response.modules) {  
        this.availableModules = response.modules;
      }
    });
  }

  mounted() {
    var button:HTMLButtonElement|null = document.querySelector( 'form[name=update-role] button.ladda-button' );
    this.laddaSubmit = Ladda.create(button!);
  }

  onFormSubmit(evt:Event) {
    // We prevent submit of the page
    evt.preventDefault();

    var input = {
      "roleID" : this.role._id,
      "modules" : this.form.modules, // We remove the white space before we split to build the array.
    }

    var options:api.ApiVueOptions =  {
      app: this
    }

    this.laddaSubmit!.start();
    
    api.postAPI('/api/admin/roles/update', input, options).then((response:any) => {
      if(response.updated) {  
        // We emit event as role is updated
        this.$emit('role-updated', response.role); 
      }
      this.laddaSubmit!.stop();
    });
  }
  
}
</script>